var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6823 4.76406L5.84059 13.6057C5.23226 12.7807 4.89893 11.7724 4.89893 10.6807V6.75573C4.89893 5.2224 5.58226 3.8474 6.66559 2.91406V6.36406C6.66559 6.68906 6.93226 6.95573 7.24893 6.95573C7.57393 6.95573 7.84059 6.68906 7.84059 6.36406V2.13906C8.22393 1.9474 8.63226 1.81406 9.05726 1.73906V4.78906C9.05726 5.1224 9.32393 5.38073 9.64893 5.38073C9.97393 5.38073 10.2406 5.1224 10.2406 4.78906V1.66406C12.2323 1.75573 13.9489 3.00573 14.6823 4.76406Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1003 7.40625V10.6896C15.1003 13.4979 12.8086 15.7896 10.0003 15.7896C9.85029 15.7896 9.70029 15.7812 9.55029 15.7646C9.48363 15.7646 9.41696 15.7562 9.35863 15.7479C9.25029 15.7312 9.14196 15.7146 9.04196 15.6979C9.00029 15.6979 8.96696 15.6812 8.91696 15.6729C8.80029 15.6479 8.68363 15.6146 8.57529 15.5813C8.39196 15.5312 8.21696 15.4646 8.05029 15.3979C7.94196 15.3562 7.84196 15.3146 7.74196 15.2562C7.71696 15.2479 7.70029 15.2312 7.67529 15.2229C7.59196 15.1813 7.50863 15.1396 7.42529 15.0812L15.1003 7.40625Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1249 9.16406V10.8307C18.1249 15.3141 14.4832 18.9557 9.9999 18.9557C8.23324 18.9557 6.54157 18.3891 5.1499 17.3474L6.0499 16.4474C7.1999 17.2641 8.56657 17.7057 9.9999 17.7057C13.7916 17.7057 16.8749 14.6224 16.8749 10.8307V9.16406C16.8749 8.8224 17.1582 8.53906 17.4999 8.53906C17.8416 8.53906 18.1249 8.8224 18.1249 9.16406Z",
    fill: "#333448",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1408 1.85938C17.8908 1.60938 17.4824 1.60938 17.2324 1.85938L1.85742 17.2427C1.60742 17.4927 1.60742 17.901 1.85742 18.151C1.98242 18.2677 2.14076 18.3344 2.30742 18.3344C2.47409 18.3344 2.63242 18.2677 2.75742 18.1427L18.1408 2.75937C18.3991 2.50937 18.3991 2.10938 18.1408 1.85938Z",
    fill: "#333448",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon01);
export default __webpack_public_path__ + "static/media/voice-icon-01.d9d8fe117cc476293061799326427527.svg";
export { ForwardRef as ReactComponent };